<template>
  <div id="app">
    <div id="toolbar">
      <el-form :model="searchdata" name="searchForm" ref="searchForm" size="small" inline>
        <el-form-item label="流水号" prop="billNo">
          <el-input v-model="searchdata.billNo" placeholder="请输入流水号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="success"><i class="fa fa-search"></i>搜索帐单</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-table v-loading="pageloading" element-loading-text="拼命加载中..." element-loading-spinner="el-icon-loading" :data="invList" stripe>
        <el-table-column prop="payNo" label="流水号"></el-table-column>
        <el-table-column prop="title" label="支付主题" width="400"></el-table-column>
        <el-table-column prop="price" label="单价"></el-table-column>
        <el-table-column prop="quantity" label="购买量"></el-table-column>
        <el-table-column prop="total" label="合计"></el-table-column>
        <el-table-column prop="currency" label="货币"></el-table-column>
        <el-table-column prop="creatTime" label="创建时间"></el-table-column>
        <el-table-column prop="status" label="结算状态">
          <template slot-scope="scop">
            <span v-if="scop.row.status">已支付</span>
            <span v-else>待支付</span>
          </template>
        </el-table-column>
        <el-table-column prop="billNo" label="结算号">
          <template slot-scope="scop">
            <span v-if="scop.row.billNo">{{ scop.row.bollNo }}</span>
            <span v-else>未对帐</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="250" align="right">
          <template slot-scope="scop">
            <span v-if="scop.row.status">
              <el-button type="text" size="small">对帐</el-button>
            </span>
            <span v-else>
              <a :href="'https://pay.safefold.com/cash?payOrderNo=' + scop.row.payNo"><el-button type="text" size="small">支付</el-button></a>
            </span>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <el-pagination
        @current-change="loadInvoice"
        :current-page="invPage.page"
        :page-sizes="[15]"
        :page-size="15"
        layout="total, sizes, prev, pager, next, jumper"
        :total="invPage.total">
      </el-pagination>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'Invoice',
  data () {
    return {
      searchdata: {},
      invList: [],
      invPage: {page: 1, 'total': 0},
      pageloading: false
    }
  },
  mounted () {
    this.loadInvoice(1)
  },
  methods: {
    loadInvoice: function (page) {
      var that = this
      this.$set(that.invPage, 'page', page)
      var para = {}
      para.method = 'merchant.invoice'
      para.page = page
      para.num = 15
      that.$http.post(that.$apiurl, para).then(function (ret) {
        that.$set(that.invPage, 'total', ret.body.data.count)
        that.invList = ret.body.data.data
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/merchant/Invoice.vue